import { z } from "zod";

import { auditDate } from "@/schemas";

import {
  egressLightSchema,
  fireExtinguisherSchema,
  smokeDetectorSchema,
} from "../../../schemas";

export const tesEquipmentCheckSchema = z.object({
  locationId: z.string().min(1, "Required"),
  auditDate: auditDate,
  reviewerId: z.string().min(1, "Required"),
  extinguishers: z.array(fireExtinguisherSchema),
  egressLights: z.array(egressLightSchema),
  smokeDetectors: z.array(smokeDetectorSchema),
  sprinklerHeadsStorage: z.string().min(1, "Required"),
  sprinklerChecked: z.string().trim().min(1, "Required"),
  sprinklerClearance: z.string().trim().min(1, "Required"),
  sprinklerIssues: z.string().trim().min(1, "Required"),
  sprinklerIssueDescription: z.string().optional(),
  waterTempLocation: z.string().trim().min(1, "Required"),
  waterTemperature: z.coerce.number().max(200),
  waterTempLocation2: z.string().trim().min(1, "Required"),
  waterTemperature2: z.coerce.number().max(200),
  hotWaterClearance: z.string().trim().min(1, "Required"),
  fireDepartmentConnection: z.string().trim().min(1, "Required"),
  firstAid: z.string().trim().min(1, "Required"),
  emergencyPlan: z.string().trim().min(1, "Required"),
  emergencyPlanFireChief: z.string().trim().min(1, "Required"),
  emergencyPlanAgencyContacts: z.string().trim().min(1, "Required"),
  emergencyPlanSupportedContacts: z.string().trim().min(1, "Required"),
  emergencySupplies: z.string().trim().min(1, "Required"),
  egressClearance: z.string().trim().min(1, "Required"),
  emergencyShutOff: z.string().trim().min(1, "Required"),
});

export const tesEquipmentCheckEditSchema = z.object({
  ...tesEquipmentCheckSchema.shape,
  auditDate: z.date(),
});
